import { getCountryLanguageNameWithFlag, getLanguageName, LanguagesCodes } from '@/configuration/lang/lang';
import { useLocaleStore } from '@/stores/localeStore';

export const useLanguageNames = (value?: string) => {
    const userLocale = useLocaleStore.getState().displayLocale;
    return LanguagesCodes.sort((a, b) =>
        getLanguageName(a, userLocale).localeCompare(getLanguageName(b, userLocale))
    ).map(languageCode => {
        const languageNameWithFlag = getCountryLanguageNameWithFlag(languageCode, userLocale);
        return {
            id: languageCode,
            label: languageNameWithFlag,
            selected: languageCode === value,
        };
    });
};
